export class LocalStorageKeys {
    public static readonly AuthRedirect: string = 'AuthRedirect';
}